// App.js - VERSION COMPLÈTE OPÉRATIONNELLE avec Admin + Stripe
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// ================================
// PAGES UTILISATEUR EXISTANTES
// ================================
import Dashboard from './pages/Dashboard';
import Conversation from './pages/Conversation';
import NewConversation from './pages/NewConversation';
import Subscription from './components/SubscriptionManager';
import Account from './pages/Account';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import SupportTicket from './components/SupportTicket';
import AffiliateRedirect from './pages/AffiliateRedirect';
import Landing from './pages/Landing';
// ================================
// PAGES STRIPE EXISTANTES
// ================================
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

// ================================
// COMPOSANTS DE PROTECTION
// ================================
import ProtectedRoute from './components/ProtectedRoute';
import { ConversationProvider } from './context/ConversationContext';

// ================================
// COMPOSANTS ADMIN (NOUVEAUX)
// ================================
import AdminRoute from './admin/components/AdminRoute';
import AdminLayout from './admin/components/AdminLayout';

// ================================
// COMPOSANTS AFFILIATE (NOUVEAUX)
// ================================
import AffiliateLogin from './pages/affiliates/AffiliateLogin';
import AffiliateDashboard from './pages/affiliates/AffiliateDashboard';
// ================================
// COMPOSANTS GOOGLE AUTOFILL
// ================================
import GoogleAuthCallback from './pages/GoogleAuthCallback';
// ================================
// COMPOSANT PRINCIPAL APP
// ================================

import TermsOfService from './pages/legal/TermsOfService';

import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import RefundPolicy from './pages/legal/RefundPolicy';
import LegalNotice from './pages/legal/LegalNotice';
import DeleteAccount from './pages/DeleteAccount';
function App() {
  console.log('🚀 DragueMaster App démarré - Version avec Admin');
  
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* ================================
              ROUTES PUBLIQUES (NON PROTÉGÉES)
              <Route path="/" element={<Login />} />
              ================================ */}

          <Route path="/terms"   element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refund"  element={<RefundPolicy />} />
          <Route path="/legal"   element={<LegalNotice />} />

          <Route path="/" element={<Landing/>} />
          
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/support" element={<SupportTicket />} />
          
          <Route path="/oauth/callback" element={<GoogleAuthCallback />} />
           
            <Route path="/r/:code" element={<AffiliateRedirect />} />
          <Route path="/affiliates/login" element={<AffiliateLogin />} />
          <Route path="/affiliates/dashboard" element={<AffiliateDashboard />} />

          <Route path="/delete-account" element={<DeleteAccount />} />
<Route path="/delete-account/confirm" element={<DeleteAccount />} />
          {/* ================================
              ROUTES UTILISATEUR PROTÉGÉES
              ================================ */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <ConversationProvider>
                <Dashboard />
              </ConversationProvider>
            </ProtectedRoute>
          } />
          
          <Route path="/conversation/new" element={
            <ProtectedRoute>
              <ConversationProvider>
                <NewConversation />
              </ConversationProvider>
            </ProtectedRoute>
          } />
          
          <Route path="/conversation/:id" element={
            <ProtectedRoute>
              <ConversationProvider>
                <Conversation />
              </ConversationProvider>
            </ProtectedRoute>
          } />
          
          {/* Page Mon Compte */}
          <Route path="/account" element={
            <ProtectedRoute>
              <ConversationProvider>
                <Account />
              </ConversationProvider>
            </ProtectedRoute>
          } />
          
          {/* Page Abonnement */}
          <Route path="/subscription" element={
            <ProtectedRoute>
              <ConversationProvider>
                <Subscription />
              </ConversationProvider>
            </ProtectedRoute>
          } />

          {/* ================================
              ROUTES STRIPE
              ================================ */}
          <Route path="/payment/success" element={
            <ProtectedRoute>
              <ConversationProvider>
                <PaymentSuccess />
              </ConversationProvider>
            </ProtectedRoute>
          } />

          <Route path="/payment/cancel" element={
            <ProtectedRoute>
              <ConversationProvider>
                <PaymentCancel />
              </ConversationProvider>
            </ProtectedRoute>
          } />

          {/* ================================
              🛡️ ROUTES ADMIN (NOUVELLES)
              ================================ */}
          <Route path="/admin/*" element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          } />
          
          {/* ================================
              ROUTE DE REDIRECTION PAR DÉFAUT
              ================================ */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;